import { BRAND_THEME } from '@pixum/theme-provider';
import Text, { TEXT_VARIANT } from '@pixum/text';
import type { NewsletterNode } from 'data-layer';
import { flattenI18n } from '../../utils/i18nConstants/flatternI18n';
import { NewsletterForm } from './NewsletterForm';
import { NewsletterTextBlock } from './NewsletterTextBlock';
import './styles.css';

/**
 * Renders the footer newsletter registration section.
 *
 * @param constants - Localized newsletter labels and messages.
 * @param showImage - Whether the newsletter illustration should be shown.
 * @param links - Optional newsletter-related links.
 */
export function NewsletterRegistration({ constants, showImage, links }: NewsletterNode) {
  const emailAddedConst = flattenI18n(constants.i18n_email_added);

  return (
    <section className="footer__newsletter">
      {showImage && (
        <div className="footer__newsletter-icon__container">
          <img
            src="https://cdn.pixum.com/images/svg/newsletter.svg"
            width="130"
            height="130"
            loading="lazy"
            alt="Newsletter illustration"
          />
        </div>
      )}
      <NewsletterTextBlock constants={constants} privacyPolicyLink={links?.privacyPolicy.url} />
      <NewsletterForm
        constants={constants}
        theme={BRAND_THEME}
        successMessage={<Text variant={TEXT_VARIANT.SUBHEADLINE}>{emailAddedConst}</Text>}
      />
    </section>
  );
}
